import { Group, Text, Tooltip } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { queryBotDatasetsList } from 'packages/app/apis/services/datasets';

interface DatasetsProps {
  id: string;
}

export const Datasets = ({ id }: DatasetsProps) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [datasets, setDatasets] = useState<string[]>([]);

  useEffect(() => {
    const fetchDatasets = async () => {
      try {
        const response = await queryBotDatasetsList({ aiId: id, page: 1, size: 1000 });
        setDatasets(response.data.items.map((item) => item.name));
      } catch (error) {
        setDatasets([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDatasets();
  }, [id]);

  if (loading) {
    return <Group gap={4}>{t('access.transfer.loading_datasets')}</Group>;
  }

  if (datasets.length === 0) {
    return <span>{t('access.transfer.no_datasets')}</span>;
  }

  return (
    <Group gap={4}>
      {datasets.map((name) => (
        <Tooltip label={name}>
          <Text className="max-w-[150px] overflow-hidden text-ellipsis whitespace-nowrap">{name}，</Text>
        </Tooltip>
      ))}
    </Group>
  );
};
